"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrashIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const TrashIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2C9.44772 2 9 2.44772 9 3V5H3C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H15V3C15 2.44772 14.5523 2 14 2H10ZM13 4H11V5H13V4Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 6.41611C20 5.67225 19.5067 5 18.8571 5H14.309H9.71429H5.14286C4.49329 5 4 5.67225 4 6.41611L5.71429 20.5772C5.71429 21.321 6.20388 22 6.85345 22L17.1429 21.9933C17.7924 21.9933 18.2857 21.321 18.2857 20.5772L20 6.41611ZM18 7H6L7.5 20H16.5L18 7Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 })] })));
};
exports.TrashIcon = TrashIcon;
//# sourceMappingURL=trash_icon.js.map